import ProjectViews from "../project-views"
import {ViewType} from "../../../gd/const/views/view-type"
import ApiProject from "../../../gd/api/project"
import ProjectView from "../project-view"
import ProjectSettings_ViewsAppSettings from "../../../manager/project/project-settings/project-views-app-settings"

export default async function projectView_deleteAll(projectViews: ProjectViews): Promise<void> {

    const views = projectViews.models.slice()

    // remove all pages first because it has specific delete procedure on backend
    while(views.length > 0) {
        const view: ProjectView | undefined = views.pop()
        if (view && view.systemType === ViewType.PROJECT_PAGE) {
            await ApiProject.deleteView(projectViews.project.id, view.id).promise()
        }
    }

    const settings = projectViews.project.settings
    if (settings) {
        settings.views = []
        settings.viewsAppSettings = new ProjectSettings_ViewsAppSettings(settings, {})
        settings.save()
    }

    gd.navigation.goToProject(projectViews.project.id)
}